import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Container from 'react-bootstrap/Container';
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table"
import Form from "react-bootstrap/Form";
import InputGroup from 'react-bootstrap/InputGroup';
import Ratio from 'react-bootstrap/Ratio';
import Button from "react-bootstrap/Button"
import { Image } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';

//import * as http from 'node:http';

import SiteData from '../config/SiteData';

import { useEffect } from "react";
import { useState, useRef } from 'react';
import {useAuth} from '../lib/StAuthGiver';
import { getCurSiteId, callApi } from '../lib/Common_funcs.js';

import JSZip from 'jszip';
//import * as fs from 'node:fs/promises';
//import { promises as fs } from 'fs';
//import * as fs from 'node:fs';

const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined?'aws':'staging');
const Tdebug = (WhichEnv != 'aws');



export const StDashSite = () => {

    const {loginAction} = useAuth();
    const {logOut} = useAuth();



    const [loading, setLoading] = useState(true);
    const [siteName, setSiteName]  = useState('');
    const [siteUrl, setSiteURL] = useState('/upload_site.png');
   
    const [createFirst, setCreateFirst] = useState(false);

    // To prevent this from loading twice.
    const isMounted = useRef(false);

    // For folder upload
    const [uploadStatus, setUploadStatus] = useState('');

    // For zip file upload
    const [zipStatus, setZipStatus] = useState('');

    // Site rename status
    const [siteRenameStatus, setSiteRenameStatus] = useState('');

    // Site upload status
    const [siteUploadStatus, setSiteUploadStatus] = useState('');

    const [siteAccessible, setSiteAccessible] = useState(false);


    Tdebug && console.log("Running the component (1) !");
    Tdebug && console.log("Site accessible is: " + siteAccessible);

    const [newSiteName, setNewSiteName] = useState('');

    const [siteReloads, setSiteReloads] = useState(0);
    const [siteId, setSiteId] = useState(getCurSiteId() || '');


    Tdebug && console.log("Running the component (2) !");
    Tdebug && console.log("Site accessible is: " + siteAccessible);

    const isUrlLive = async (host) => {

        try {

            // Below is our own API endpoint to act as a proxy to get around CORS.
            const rc = await fetch(getApiServer() + '/isl?url=' + encodeURIComponent(host), {
                method: 'GET',
            });

            Tdebug && console.log(rc);
            Tdebug && console.log(JSON.stringify(rc));
            Tdebug && console.log(rc.ok);

            /* This also works, but below is better.
            if (rc.ok == true) {
                    return true;
            }
            */


            const response = await rc.json();
            Tdebug && console.log("Logging response now...");
            Tdebug && console.log("Stringified is: " + JSON.stringify(response));
            Tdebug && console.log(response);

            if (response.statusCode != 200) {
                return false;
            }
            else {
                return true;
            }
        }
        catch (e) {
            console.log(e);
            console.log("catch for fetch try");
            return false;
        }
    }

    const isUrlLive2 = async (host) => {
        
        try {

            // NOTE: USING A PROXY URL BELOW TO BYPASS CORS.
            const rc = await fetch(getApiServer() + '/isl?url=' + encodeURIComponent(host), {
                method: 'GET',
                //mode: "no-cors",
                //mode: "cors",
                /*
                headers: {
                    "Accept": "text/html"
                }
                */
            }).then((response) => {
                Tdebug && console.log(JSON.stringify(response));
                Tdebug && console.log(response);
    
                Tdebug && console.log('https ok', response.ok);
                Tdebug && console.log('https status', response.status);
                Tdebug && console.log('https statusText', response.statusText);
    
                if (response.ok == false) {
                    setSiteAccessible(false);
                    return false;
                }
                else {
                    setSiteAccessible(true);
                    return true;
                }
            }).catch((response) => {
                Tdebug && console.log("The URL is not live");
    
                Tdebug && console.log(response);
                Tdebug && console.log(response.status);
                setSiteAccessible(false);
                return false;
            });
        }   
        catch (e) {
            console.log("catch for fetch try");
            setSiteAccessible(false);
            return false;
        }
    }
    

    const refreshSite = (refcnt) => {
        //setSiteReloads(siteReloads - 1);

        //const refcnt = siteReloads;
        const nextCnt = refcnt - 1;
        console.log("Next reload at " + nextCnt)

        setTimeout((nextCnt) => {
            // Callback when the timer expires
            // We will reload till the number of reloads goes to 0.
            Tdebug && console.log(new Date().getTime() + ", this was set at cnt: " + nextCnt.toString());
            
            if ((nextCnt - 1) > 0) {
                reloadSite(nextCnt - 1);
            }

        }, 2000);
    }

    const reloadSite = () => {
        setSiteReloads(siteReloads + 1);  // Increment the value by one and force a reload of the iframe.

        /*
        Tdebug && console.log(new Date().getTime() + ", reloads pending: " + cnt.toString());

        
        if (cnt > 0) {
            refreshSite(cnt);
        }
        */
/*
        setInterval(() => {
            // Callback when the timer expires
            // We will reload till the number of reloads goes to 0.
            Tdebug && console.log(new Date().getTime() + ", reloads pending: " + siteReloads.toString());
            if (siteReloads > 0) {
                setSiteReloads(siteReloads - 1)
            }
            else {
                setSiteReloads(0);
            }

        }, 2000) // Set a refresh interval of every 2 seconds for 5 times.

        */
    }

    //const createBlobFromFile = async path => new Blob([ await fs.promises.readFile(path) ]);

    const getApiServer = () => {
        if (WhichEnv === 'aws') {
            return 'https://api-us.turbosteed.com';
        }
        else {
            return `https://${process.env.REACT_APP_HOST_URL}`;
        }   
    }

    /*
    const isUrlLive = (host,callback) => {
        http.request({method:'HEAD',host,port:80,path: '/'}, (r) => {
            callback(null, r.statusCode >= 200 && r.statusCode < 400 );
        }).on('error', callback).end();
    }
        */

    


    const handleFileChange = async (event) => {

        Tdebug && console.log(event);
        //Tdebug && console.log(JSON.stringify(event));

        const file = event.target.files[0];

        if (file && file.type === 'application/zip') {
            //const formData = new FormData();
            //formData.append('file', file, file.name);
            
            //const zipfile = new Blob(URL.createObjectURL(file), {type: "application/zip"});
            //const formData = new FormData();
            //formData.append('file', zipfile, file.name);

            // Convert file to base64
            /*
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            const boundary = '------------------------yPCtxbVPhyhhYYmlUlnfOT';
      
            fileReader.onload = async () => {
                // Remove the data URL prefix to get just the base64 string
                const base64Data = fileReader.result.split(',')[1];

                const formData = [
                    `--${boundary}`,
                    'Content-Disposition: attachment; name="file"; filename="' + file.name + '"',
                    'Content-Type: application/octet-stream',
                    '',
                    //base64Data,
                    new Uint8Array(fileReader.result)
                    `--${boundary}--`
                ].join('\r\n');
            */

                    const formData = new FormData();

                    const fileBlob = new Blob([file], {type: 'applicaiton/octet-stream'});
                    formData.append('file', fileBlob, file.name)

                    let respMsg = '';

                    try {
                        const acctSid = localStorage.getItem('turbosteedAcct');
                        const act_e = localStorage.getItem('act_e');
                
                        Tdebug && console.log("StDashSite: acctSid: " + acctSid);
                        Tdebug && console.log("StDashSite: acctSid: " + act_e);

                        setZipStatus('Uploading...');

                        

                        const response = await fetch(getApiServer() + '/users/' + acctSid + '/sites/' + siteId + '/upload', //new URLSearchParams({code: authCode}).toString(), 
                        {
                            method: 'PUT',
            
                            withCredentials: 'true',     
                            credentials: 'include',   // Browser will send the cookies along with the request. (include => for CORS)
                            headers: {
                                //'Content-Type': 'application/zip',
                                //'Content-Type': undefined,
                                'Authorization': 'Basic ' + btoa(acctSid + ':' + act_e),
                                //'Content-Type': 'application/zip; boundary=' + boundary,
                                //'Content-Length': formData.length.toString(),
                                //'Content-Transfer-Encoding': 'base64'
                            },
                            body: formData
                        }).then(async (response) => {
                            Tdebug && console.log(response);
                            Tdebug && console.log(response.headers);
                            Tdebug && console.log(response.data);
                            Tdebug && console.log(JSON.stringify(response));

                            // Account SID cannot change, hence, only check for
                            // the new token.
                            const jsonBody = await response.json();
                            if ((jsonBody.etac !== undefined) && (jsonBody.etac !== null)) {

                                let encAuth = jsonBody.etac;
                                loginAction(null, encAuth);
                            }

                            respMsg = jsonBody.message;
                            console.log(jsonBody);
                            console.log(respMsg);
                            

                            if (response.ok == false) {
                                throw new Error(respMsg);
                            }
                
                            return jsonBody;
                        }).then((responseJson) => {
                                Tdebug && console.log(responseJson);

                                // Account SID cannot change, hence, only check for
                                // the new token.
                                if ((responseJson.etac !== undefined) && (responseJson.etac !== null)) {

                                    let encAuth = responseJson.etac;
                                    loginAction(null, encAuth);
                                }

                                setSiteAccessible(true);
                                reloadSite();

                                setZipStatus("Upload successful. Please wait for 5 mins and click refresh above");
                        })
                    } catch (error) {
                        setZipStatus('Error during upload: ' + error.message);

                        console.log(error);
                        //const body = error.json();
                        //const message = body.message;

                        //const message = await error.response.text();
                        // console.log(body);
                        //console.log(message);

                        //setUploadStatus(error.message);
                        setZipStatus(respMsg);
                    }
                //}
                /*
                fileReader.onerror = (error) => {
                    setZipStatus('Error reading file');
                    console.error('Error: ', error);
                  };
                  */
        } else {
            setZipStatus('Please select a valid zip file.');
        }
    }

    // Handle a folder drop in the drop area.
    const handleDrop = async (evt) => {

        evt.preventDefault();
        const items = evt.dataTransfer.items;

        const zip = new JSZip();

        const addFileToZip = (file, path) => {

            return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        zip.file(path, reader.result);
                        resolve();
                    }

                    reader.readAsArrayBuffer(file);

            })

        }

        const processEntries = async (entries, path = '') => {
            for (const entry of entries) {
                if (entry.isFile) {
                    await new Promise((resolve) => {
                        entry.file(async (file) => {
                            await addFileToZip(file, path + file.name);
                            resolve();
                        });
                    });
                } else if (entry.isDirectory) {
                    const directoryReader = entry.createReader();
                    directoryReader.readEntries(async (subEntries) => {
                        await processEntries(subEntries, path + entry.name + '/');
                    });
                }
            }
        };

        for (const item of items) {
            if (item.kind === 'file') {
                const entry = item.webkitGetAsEntry();
                if (entry.isDirectory) {
                    const directoryReader = entry.createReader();
                    directoryReader.readEntries(async (entries) => {
                        await processEntries(entries);
                        zip.generateAsync({ type: 'blob' }).then(async (content) => {
                            const formData = new FormData();
                            formData.append('file', content, 'uploaded-folder.zip');

                            try {
                                const acctSid = localStorage.getItem('turbosteedAcct');
                                const act_e = localStorage.getItem('act_e');
                        
                                Tdebug && console.log("StDashSite: acctSid: " + acctSid);
                                Tdebug && console.log("StDashSite: acctSid: " + act_e);



                                setUploadStatus('Uploading...');

                                const response = await fetch(getApiServer() + '/users/' + acctSid + '/sites/' + siteId + '/upload', //new URLSearchParams({code: authCode}).toString(), 
                                {
                                    method: 'PUT',
                    
                                    withCredentials: 'true',     
                                    credentials: 'include',   // Browser will send the cookies along with the request. (include => for CORS)
                                    headers: {
                                        'Content-Type': 'application/zip',
                                        'Authorization': 'Basic ' + btoa(acctSid + ':' + act_e)
                                    },
                                    body: formData
                                }).then((response) => {
                                    Tdebug && console.log(response);
                                    Tdebug && console.log(response.headers);
                                    Tdebug && console.log(response.data);
                                    Tdebug && console.log(JSON.stringify(response));

                                    // Account SID cannot change, hence, only check for
                                    // the new token.
                                    const jsonBody = response.json();
                                    if ((jsonBody.etac !== undefined) && (jsonBody.etac !== null)) {

                                        let encAuth = jsonBody.etac;
                                        loginAction(null, encAuth);
                                    }

                                    if (response.ok == false) {
                                        throw new Error(jsonBody);
                                    }
                        
                                    return jsonBody;
                                 }).then((responseJson) => {
                                        Tdebug && console.log(responseJson);

                                        // Account SID cannot change, hence, only check for
                                        // the new token.
                                        if ((responseJson.etac !== undefined) && (responseJson.etac !== null)) {

                                            let encAuth = responseJson.etac;
                                            loginAction(null, encAuth);
                                        }
                                })
                            } catch (error) {
                                setUploadStatus('Error during upload: ' + error.message);
                            }
                        });
                    });
                }
            }
        }

    }
    

    const getIframeUrl =  () => {
        const randomUrl = (siteUrl + "/turbocache?turbonckey=" + new Date().getTime())
        Tdebug && console.log(randomUrl);
        
        return randomUrl;
    }

    const updateSiteName =  async (event) => {

        Tdebug && console.log("updateSiteName: event is: " + event);

        const acctSid = localStorage.getItem('turbosteedAcct');
        const act_e = localStorage.getItem('act_e');

        Tdebug && console.log("StDashSite: acctSid: " + acctSid);
        Tdebug && console.log("StDashSite: acctSid: " + act_e);

        Tdebug && console.log("StDashSite: Site ID is" + siteId);

        Tdebug && console.log("StDashSite: new name is: " + newSiteName);


        // Check if the user has never created a site, or is it a genuine error.
        if ((!siteId.length) && (createFirst == false)) {
            return;
        }

        if (!newSiteName.length) {
            Tdebug && console.log("Empty site name!")
            return;
        }

        try {
        
            //const response = await fetch('http://127.0.0.1:4000/users/f103ad881cafc3aec513ece0a7fe0628', //new URLSearchParams({code: authCode}).toString(), 
            const response = await fetch(getApiServer() + '/users/' + acctSid + (siteId.length? ('/sites/' + siteId) : ('/sites')), //new URLSearchParams({code: authCode}).toString(), 
            {
                method: 'PUT',
            
                withCredentials: 'true',     
                credentials: 'include',   // Browser will send the cookies along with the request. (include => for CORS)
                //body: authCode,
                headers: {
                    //'Access-Control-Allow-Origin': 'http://localhost:3000', 
                    'Content-Type': 'application/json',
                    //'Authorization': 'Basic ' + btoa('f103ad881cafc3aec513ece0a7fe0628:df0fcf9b0dad1b2fab1d4e7a1e8700bdfeeef48a1d169c517f52635ae3e224af')
                    'Authorization': 'Basic ' + btoa(acctSid + ':' + act_e)

                },
                body: JSON.stringify({
                    siteName: newSiteName
                })
            }).then((response) => {
                Tdebug && console.log(response);
                Tdebug && console.log(response.headers);
                Tdebug && console.log(response.data);
                Tdebug && console.log(JSON.stringify(response));

                // Account SID cannot change, hence, only check for
                // the new token.
                const jsonBody = response.json();
                if ((jsonBody.etac !== undefined) && (jsonBody.etac !== null)) {

                    let encAuth = jsonBody.etac;
                    loginAction(null, encAuth);
                }

                if (response.ok == false) {
                    throw new Error(jsonBody);
                }
                
                return jsonBody;
            }).then((responseJson) => {
                Tdebug && console.log(responseJson);

                // Account SID cannot change, hence, only check for
                // the new token.
                if ((responseJson.etac !== undefined) && (responseJson.etac !== null)) {

                    let encAuth = responseJson.etac;
                    loginAction(null, encAuth);
                }

                // Was the response for creating the first site? Or updating the existing one?
                if (createFirst == true) {
                    siteId = responseJson.siteId;
                    setSiteId(siteId);
                    setCreateFirst(false);
                    setSiteName(newSiteName);
                    
                }
                else {

                    setSiteName(responseJson.siteName);

                    const rc_siteUrl = "https://" + responseJson.siteName + ".turbosteed.com";
                    setSiteURL(rc_siteUrl);

                    //const urlLive = isUrlLive(rc_siteUrl);
                    isUrlLive(rc_siteUrl)
                    .then((result) => {
                        setSiteAccessible(result);
                    }).catch((err) => {
                        Tdebug && console.log("isUrlLive error!");
                    })

                    //setSiteAccessible(urlLive);
                }

                // The site name needs to be updated in the local storage.
                const curSiteIdx = localStorage.getItem('curSiteIdx');
                let currentSites = JSON.parse(localStorage.getItem("sites"));
            
                Tdebug && console.log(curSiteIdx);
                Tdebug && console.log(currentSites);

                currentSites[curSiteIdx]["siteName"] = responseJson.siteName;
                localStorage.setItem("sites", JSON.stringify(currentSites));
                Tdebug && console.log(currentSites);

                Tdebug && console.log(siteName);
                Tdebug && console.log(siteUrl);
                Tdebug && console.log(siteId);

                //return response.json();
            }).catch((error) => {
                Tdebug && console.log(error);
                Tdebug && console.log("Will not take action!");

                logOut();


            });
        } catch (axe) {
            Tdebug && console.log(axe);
            setSiteRenameStatus(axe.message);

        }
    
    }

    useEffect(() => {

           
        if (isMounted.current == false) {
            isMounted.current = true;
        }
        else {
            return;
        }

        const fetchData = async() => {

            const curSiteId = getCurSiteId();

            const rcJson = await callApi('/sites/' + curSiteId, 'GET', {}, {});

            Tdebug && console.log(rcJson);

            if (rcJson.disposition == 'logout') {
                Tdebug && console.log("Now logging out");
                logOut();
            }

            if (rcJson.httpStatus != 200) {

                if (rcJson.disposition == 'retry') {
                    Tdebug && console.log(rcJson.message);
                    // Handle retry.
                }
                else if (rcJson.disposition == 'abort') {
                    // Handle error.
                    Tdebug && console.log(rcJson.message);
                    //setLoading(false);

                }
                
            }
            else {

                // If hte cookie has changed, update it.
                if (rcJson.respBody.etac) {
                    loginAction(null, rcJson.etac);
                }
                
                Tdebug && console.log("Received site details");
                Tdebug && console.log(rcJson);

                setSiteName(rcJson.respBody.siteName);
                const rc_siteUrl = "https://" + rcJson.respBody.siteName + ".turbosteed.com";
                setSiteURL(rc_siteUrl);

                
                isUrlLive(rc_siteUrl)
                        .then(result => {
                            Tdebug && console.log("isUrlLive returned, site status is: " + result);
                            setSiteAccessible(result);
                            //Tdebug && console.log("useState: Site accessible");
                        }).catch(err => {
                            Tdebug && console.log("isUrlLive error!");
                        })
                
                /*
                const isUrlLiveRes = await isUrlLive(rc_siteUrl);
                Tdebug && console.log("isUrlLive returned: " + isUrlLiveRes);
                setSiteAccessible(isUrlLiveRes);
                */

                Tdebug && console.log("Set loading to false as we have the information");
                
                setLoading(false);
            }

            
        }
        
        fetchData();
        
    }, //[siteName, siteUrl, siteAccessible]);
    [siteName, siteUrl]);

    useEffect(() => {
        // Just refresh the page.
        Tdebug && console.log("useEffect[siteAccessible] : Site accessible value is: " + siteAccessible);
    }, [siteAccessible]);

    Tdebug && console.log("Site accessible is: " + siteAccessible);

    if (loading == true) {

        return (
            <div>
                <span className="page-title">Site Settings</span>
                <div className="position-relative w-100 h-100 d-flex flex-column align-items-center bg-white justify-content-center">
                    <Spinner animation="border" variant="primary" />
                    <div className="mt-2 pt-2">Loading...</div>
                </div>

            </div>


        );
    }
    else {


        return (
            <div>
                
                {/*
                    <Breadcrumb className="">
                        <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                        <Breadcrumb.Item active>Site</Breadcrumb.Item>
                    </Breadcrumb>
                */}
                <span className="page-title">Site Settings</span>

                <Container className="d-flex flex-column">    

                        <InputGroup className="d-flex flex-row">
                            <InputGroup.Text className="site-data-keys mt-2">Site Name</InputGroup.Text>
                            <Form.Control className="mx-2" placeholder={siteName.length?siteName:'Your site name'}   
                               aria-label='Your site name' onChange={event => {
                                setNewSiteName(event.target.value)
                            }} />
                            <InputGroup.Text id="basic-addon2" className="mt-2">.turbosteed.com</InputGroup.Text>
                            
                            <Button variant="primary mx-3"  type="submit" onClick={(e) => updateSiteName(e)}> 
                                {(createFirst == true)? 'Create': 'Update'} 
                            </Button>
                            
                            {/*
                            <Button  type="submit" className="d-flex primary mx-3"  onClick={(e) => updateSiteName(e)}> 
                                {(createFirst == true)? 'Create': 'Update'} 
                            </Button>
                            */}

                                <span className="color-warning">{siteRenameStatus.length?siteRenameStatus:''}</span>
                            
                        </InputGroup>

                        {/*
                            (Tdebug && console.log(SiteData.siteType)) && (SiteData.siteType == 'subdomain')?<p> Use a <a href="#help">Custom Domain</a> to enhance your web presence </p>:<div>Upgrade</div>
                        */}

                        <p></p>
                        <span className="site-data-keys mb-2">
                            Site content
                            <i className="bi-arrow-clockwise mx-2" onClick={() => reloadSite()}></i>
                        </span>
                        {/*<Button variant="primary" onClick={() => reloadSite()}>Reload</Button>*/}
                        
                        {
                            (siteAccessible == true)?
                                <Ratio aspectRatio="16x9">
                        
                                    {/* <iframe className="my-2"  src={siteUrl} title="Your Website" /> */}
                                
                                    <iframe key={siteReloads} className="my-2" src={getIframeUrl()} title="Your Website" referrerPolicy="no-referrer" />
                                </Ratio>:
                                <Image src="/upload_site.png"></Image>

                        }


                        {/*            
                            <Container className="d-flex flex-row">    
                                <Button variant="primary" className="mx-0 my-4">Upload Zip</Button>
                                <Button variant="primary" className="mx-2 my-4">Save</Button>
                                <Button variant="warning" className="mx-0 my-4">Cancel</Button>
                            </Container>        

                            <p> OR </p>
                            <div onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} style={{ border: '2px dashed #cccccc', padding: '20px', textAlign: 'center' }} >
                                <p>Drag and drop a folder here</p>
                                <p>{uploadStatus}</p>
                            </div>
                        */}
                        <div>
                            <p></p>
                            <p> Upload your site's zip file </p>
                            <input
                                type="file"
                                accept=".zip"
                                onChange={handleFileChange}
                            />
                            <p className="mt-2">{zipStatus}</p>
                        </div>


                </Container>
            </div>
        );
    }   
}

export default StDashSite;